import * as React from 'react';

function ChevronLeftSmall(props) {
    return React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "c-pieIcon c-pieIcon--ChevronLeftSmall", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M9.96002 1.82L4.60503 7L10.0038 12.1975L9.12878 13.16L3.56378 7.79625C3.45185 7.68776 3.36285 7.55789 3.30208 7.41434C3.24131 7.2708 3.20999 7.1165 3.20999 6.96062C3.20999 6.80474 3.24131 6.65045 3.30208 6.50691C3.36285 6.36336 3.45185 6.23349 3.56378 6.125L9.05878 0.875L9.96002 1.82Z" }));
}

export { ChevronLeftSmall as default };
